import React from 'react';
import CommentSkeleton from '../../lego/CommentSkeleton';
import SpamView from '../../commonSkeletonViews/SpamView';
import HiddenView from '../../commonSkeletonViews/HiddenView';
import EditView from '../../commonSkeletonViews/EditView';
import ReadView from './ReadView';
const Comment = ({ comment, canPostComment, includeFooter, className, orphanView, onReplyPosted, onEditingStateChange, onCommentUpdated })=>{
    return /*#__PURE__*/ React.createElement(CommentSkeleton, {
        className: className,
        comment: comment,
        onEditingStateChange: onEditingStateChange,
        readView: /*#__PURE__*/ React.createElement(ReadView, {
            includeFooter: includeFooter,
            canPostComment: canPostComment,
            onReplyPosted: onReplyPosted
        }),
        spamView: /*#__PURE__*/ React.createElement(SpamView, null),
        hiddenView: /*#__PURE__*/ React.createElement(HiddenView, null),
        editingView: /*#__PURE__*/ React.createElement(EditView, {
            canPostComment: canPostComment,
            onCommentUpdated: onCommentUpdated
        }),
        // Some usages of this preset provide their own orphanView
        // TODO: Clean that up. Create a new preset over there instead?
        orphanView: orphanView
    });
};
Comment.displayName = 'Comment';
export default Comment;
